import Combobox from "@github/combobox-nav"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  declare private combobox: Combobox

  static targets = ["input", "listbox"]
  declare readonly inputTarget: HTMLInputElement
  declare readonly listboxTarget: HTMLOListElement

  disconnect(): void {
    this.combobox?.destroy()
  }

  listboxTargetConnected(): void {
    this.start()
  }

  start(): void {
    this.combobox?.destroy()

    this.combobox = new Combobox(this.inputTarget, this.listboxTarget)
    this.combobox.start()
    this.listboxTarget.hidden = false
  }

  stop(): void {
    this.combobox?.stop()
    this.listboxTarget.hidden = true
  }
}
